import { getEnv } from "../../../../utils/env"
import queryString from "query-string"
import { getRequest } from "../../../mp-utils/generic-utils"

/**
 * Requests a groupUA update from a cloud function
 * @param {string} groupId id of the district, school, teacher or class
 * @param {string} assessmentId id of the assessment
 * @param {*} year school year (e.g. 2018)
 */
export default function requestGroupUAUpdate(
  groupId,
  assessmentId,
  year,
  m_gua
) {
  const BASE_URL = `${getEnv(
    "CLOUD_FUNCTION_ROOT"
  )}/aggregatesGroup-updateGroupUA?`
  const queryObj = {
    assessmentId,
    groupId,
    year,
    m_gua
  }
  const query = queryString.stringify(queryObj)
  const endpoint = BASE_URL + query
  return getRequest(endpoint, 540000)
}
